import Serial from "./Serial";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageButtons from "../../components/PageButtons";
import { useSerials } from "../../hooks/UseSerials";
import { useForm } from "react-hook-form";
import {PAGINATION} from "../../constants";

const PAGE_SIZE = PAGINATION.SERIALS_PAGE_SIZE;

function SerialList(params) {
    const user = params.user;
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const currentPage = Number.parseInt(searchParams.get('page') ?? '1');
    const pageSearch = searchParams.get('filter') ?? '';

    const useSerialsHook = useSerials();
    const { register, handleSubmit, reset } = useForm({
        defaultValues: { search: pageSearch }
    });

    const onButtonClicked = (index) => {
        setSearchParams({ page: index, filter: pageSearch });
        window.scrollTo(0, 0);
    }

    const onEditClicked = (serial) => {
        navigate(`/serials/edit?id=${serial.id}`);
    }

    // When searching - always go to page 1
    function OnSearchClicked(data) {
        const newFilter = data.search || '';
        setSearchParams({ page: 1, filter: newFilter });
    }

    useEffect(() => {
        useSerialsHook.loadCount(user.token, pageSearch);
    }, [user.token, pageSearch]);

    useEffect(() => {
        const offset = (currentPage - 1) * PAGE_SIZE;

        if (user.token) {
            console.log("🚀 Завантаження сторінки:", currentPage, "Offset:", offset);
            useSerialsHook.loadAll(user.token, PAGE_SIZE, offset, pageSearch);
        }

    }, [user.token, currentPage, pageSearch]);

    const totalPages = Math.ceil((useSerialsHook.count || 0) / PAGE_SIZE);

    if (useSerialsHook.loading && !useSerialsHook.serials) {
        return <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>;
    }

    const serialsElements = useSerialsHook.serials?.map(m => (
        <Serial user={user} serial={m} onEditClicked={onEditClicked} key={m.id}/>
    ));

    console.log("Отримано серіалів:", useSerialsHook.serials?.length);

    return (
        <div>
            {/* Search Panel */}
            <div style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '12px', marginBottom: '20px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
                <form onSubmit={handleSubmit(OnSearchClicked)} style={{ display: 'flex', gap: '10px' }}>
                    <input
                        style={{ flex: 1, padding: '10px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none' }}
                        {...register('search')}
                        placeholder="Пошук за назвою..."
                    />
                    <button type="submit" style={{ padding: '10px 25px', borderRadius: '8px', border: 'none', backgroundColor: '#1f2937', color: '#fff', cursor: 'pointer' }}>
                        Знайти
                    </button>
                </form>
            </div>

            {/* Serials Grid */}
            {useSerialsHook.count === 0 ? (
                <div style={{ textAlign: 'center', padding: '50px', color: '#6b7280' }}>Нічого не знайдено</div>
            ) : (
                <>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(450px, 1fr))',
                        gap: '20px',
                        paddingBottom: '30px'
                    }}>
                        {serialsElements}
                    </div>

                    {/* Pagination if >1 pages */}
                    {totalPages > 1 && (
                        <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                            <PageButtons totalPages={totalPages} currentPage={currentPage} onButtonClicked={onButtonClicked}/>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}

export default SerialList;